import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getInstallations(pageSize: number) {
  try {
    const resp = await axios.get(`/api/installations/?pageSize=${pageSize}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function searchInstallations(query: object) {
  let searchQuery = getQueryString(query);
  try {
    const resp = await axios.get("/api/installations/search?" + searchQuery);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createInstallation(installation: object) {
  try {
    const resp = await axios.put("/api/installations/Create/", installation);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateInstallation(installation: object) {
  try {
    const resp = await axios.post("/api/installations/update/", installation);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function deleteInstallation(installationId: string) {
  try {
    const resp = await axios.delete(
      "/api/installations/delete?id=" + installationId
    );
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getInstallationById(installationId: string) {
  try {
    const resp = await axios.get(
      "/api/installations/" + installationId + "/details"
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
